import { COLORS } from "../../common/constants";

const styles = {
  mainContainer: {},
  heading: {
    font: "normal normal 700 21px/24px MrEavesXLSanOT",
    padding: "0 0 10px 0",
  },
  fieldContainer: {},
  btnContainer: {
    margin: "25px 0 0",
    color: COLORS.loginbutton,
    "& .MuiButton-root.Mui-disabled": {
      color: COLORS.white,
    },
  },
  btnContainer1: {
    padding: "55px 0 20px 0",
    "& .MuiButton-root.Mui-disabled": {
      color: COLORS.white,
    },
  },
  btn: {
    backgroundColor: COLORS.loginbutton,
    color: COLORS.white,
    borderRadius: "8px",
    padding: "20px 4px",
    font: "normal normal 500 14px/25px mreavesxlsanot-reg",
    height: "57px",
    "&:hover": {
      backgroundColor: COLORS.loginbutton,
      color: COLORS.white,
    },
  },
  backToLoginBtn: {
    margin: "22px auto",
  },
  email: {},
  eyeIcon: {
    color: COLORS.primary,
  },
  none: {
    visibility: "hidden",
  },
  innerContainer: {},
  textField: {},
  otpcontainer: {
    display: "flex",
    justifyContent: "space-between",
    "& div": {
      justifyContent: "space-between",
      width: "100%",
      marginBottom: "5px",
    },
  },
  boxcontainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "20px",

    "& .customInput": {
      width: "100% !important",
    },
  },
  label: {
    color: COLORS.black,
    font: "normal normal 400 18px/24px MrEavesXLSanOT",
    marginBottom: "10px",
    display: "inline-block",
  },
  authInput: {
    "& input": {
      padding: "19.5px 14px",
      color: COLORS.inputHead,
      font: "normal normal 400 16px/16px MrEavesXLSanOT",
      "&::placeholder": {
        color: COLORS.placeholder,
        opacity: "1 !important",
        letterSpacing: "0.59px",
        Opacity: "40%",
        font: "normal normal 500 16px/16px MrEavesXLSanOT",
      },
      "&:-internal-autofill-selected": {
        backgroundColor: "transparent",
      },
    },
    "& textarea": {
      color: COLORS.inputHead,
      font: "normal normal 500 16px/16px MrEavesXLSanOT",
      "&::placeholder": {
        color: COLORS.placeholder,
        opacity: "1 !important",
        letterSpacing: "0.59px",
        font: "normal normal 500 16px/16px  MrEavesXLSanOT",
      },
      "&:-internal-autofill-selected": {
        backgroundColor: "transparent",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #D1D1D1 !important",
    },
    "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
      {
        border: "2px solid #D1D1D1 !important",
      },
    "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-active .MuiOutlinedInput-notchedOutline":
      {
        border: "2px solid #D1D1D1 !important",
      },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      font: "normal normal 500 16px/16px MrEavesXLSanOT",
      // height:"62px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000",
      },
      "&.Mui-active .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000",
      },
      "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #E71515",
      },
    },
  },

  resend: {
    color: "#000",
    fontSize: "16px",
    fontWeight: "400",
    margin: "20px 0",
    textAlign: "center",
  },
  backtologin: {
    display: "flex",
    marginBottom: "40px",
  },
  btnback: {
    width: "auto",
    backgroundColor: "transparent",
    color: "auto",
    boxShadow: "none",
    padding: "0",
    font: "normal normal 500 14px/25px mreavesxlsanot-reg",
    "&:hover": {
      backgroundColor: "transparent",
      color: "inherit",
      boxShadow: "none",
    },
  },
  btnwrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& a": {
      color: "#000",
      font: "normal normal 400 16px/25px mreavesxlsanot-reg",
      margin: "20px 0 0",
      textAlign: "center",
      textDecoration: "underline",
      cursor: "pointer",
    },
  },
  btnwrapperresend: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& a": {
      color: "#000",
      font: "normal normal 400 16px/25px mreavesxlsanot-reg",
      margin: "20px 0 0",
      textAlign: "center",
      cursor: "pointer",
    },
  },
};

export default styles;
